<template>
	<el-row class="container">
		<el-col :span="24" style="display:flex;justify-content: space-between;">
			<div class="title">
				<el-link :underline="false" @click.native="$router.push('/');"><img src="~assets/images/logo.svg" style="width:129px;margin-top:20px;margin-left:-16px;"></el-link>
			</div>

			<!-- <div class="header-el-menu">
				<div><a href="javascript:void(0);" @click="service()" style="color: #E4BB7B;">聯繫客服</a></div>
			</div> -->

			<div >
				<el-menu :default-active="activeIndex" class="main-bar-el-menu" mode="horizontal" @select="handleSelect" :router="true">
					<!-- <el-menu-item index="/" class="bar-item">首頁</el-menu-item> -->
					<el-menu-item index="/home-work" class="bar-item">家庭手工</el-menu-item>
					<el-menu-item index="/purchasing" class="bar-item">連線代理</el-menu-item>
					<el-menu-item index="/order" class="bar-item">其他流量</el-menu-item>
					<el-menu-item index="/lottery" class="bar-item">彩票遊戲</el-menu-item>
					<el-menu-item index="/live" class="bar-item">真人遊戲</el-menu-item>
					<!-- <el-menu-item index="/info/bulletin" class="bar-item">體育賽事</el-menu-item> -->
				</el-menu>
			</div>
			<div v-if="!user.isLogin" style="color:var(--secondary-color);line-height: 60px;">
				<span @click="$router.push('/uc/login');" style="cursor: pointer;">登錄</span> | <span @click="$router.push('/uc/register');" style="cursor: pointer;">註冊</span>
			</div>
			<div v-else >
				<el-dropdown size="medium" @command="handleCommand" :show-timeout="100" style="margin-top: 12px;">
					<span style="margin-top: 10px;">
						<el-tag size="small"> 錢包 ${{ wallet || '0.00'}}</el-tag>

						<span class="el-dropdown-link">
							<el-badge :is-dot="this.user.unread?true:false" :hidden="this.user.unread == 0" class="dot-item" >
								<icon name="user-circle" scale="2" class="user-circle"></icon>
							</el-badge>
						</span>

					</span>
					<el-dropdown-menu slot="dropdown" class="header-user-menu">
						<el-dropdown-item command="/user/wallet"><span class="menu-icon wallet"></span>資產總覽</el-dropdown-item>
						<el-dropdown-item command="/user/deposit"><span class="menu-icon deposit"></span>快速存款</el-dropdown-item>
						<el-dropdown-item command="/user/withdraw"><span class="menu-icon withdraw"></span>提款專區</el-dropdown-item>
						<el-dropdown-item command="/user/transfer-log"><span class="menu-icon transfer-log"></span>資金記錄</el-dropdown-item>
						<el-dropdown-item command="/user/bet-log"><span class="menu-icon bet-log"></span>演算查詢</el-dropdown-item>
						<el-dropdown-item command="/user/Info"><span class="menu-icon info"></span>個人資料</el-dropdown-item>
						<el-dropdown-item command="/user/mail">
							<el-badge :value="this.user.unread" :hidden="this.user.unread == 0" class="header-mail-dot-number">
							<span class="menu-icon mail"></span>站內消息
							</el-badge>
						</el-dropdown-item>
						<el-dropdown-item @click.native="logout()" divided><span class="menu-icon logout"></span>登出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

			<!-- <div class="login-block">
				<div v-if="!user.isLogin">
					<a href="javascript:void(0);" @click="login()">登錄</a> | <router-link to="/register">註冊</router-link>
				</div>
				<div v-else>
					<el-dropdown size="medium" @command="handleCommand" :show-timeout="100">
						<span>
							<el-tag size="small"> 錢包 ${{ wallet || '0.00'}}</el-tag>

							<span class="el-dropdown-link">
								<el-badge :is-dot="this.user.unread?true:false" :hidden="this.user.unread == 0" class="dot-item">
									<icon name="user-circle" scale="2" class="user-circle"></icon>
								</el-badge>
							</span>

						</span>
						<el-dropdown-menu slot="dropdown" class="header-user-menu">
							<el-dropdown-item command="/user/wallet"><span class="menu-icon wallet"></span>資產總覽</el-dropdown-item>
							<el-dropdown-item command="/user/deposit"><span class="menu-icon deposit"></span>快速存款</el-dropdown-item>
							<el-dropdown-item command="/user/withdraw"><span class="menu-icon withdraw"></span>提款專區</el-dropdown-item>
							<el-dropdown-item command="/user/transfer-log"><span class="menu-icon transfer-log"></span>資金記錄</el-dropdown-item>
							<el-dropdown-item command="/user/bet-log"><span class="menu-icon bet-log"></span>演算查詢</el-dropdown-item>
							<el-dropdown-item command="/user/Info"><span class="menu-icon info"></span>個人資料</el-dropdown-item>
							<el-dropdown-item command="/user/mail">
								<el-badge :value="this.user.unread" :hidden="this.user.unread == 0" class="header-mail-dot-number">
								<span class="menu-icon mail"></span>站內消息
								</el-badge>
							</el-dropdown-item>
							<el-dropdown-item @click.native="logout()" divided><span class="menu-icon logout"></span>登出</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div> -->



		</el-col>
	</el-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			//wallet : 10,
			activeIndex: this.$router.currentRoute.path,

		};
	},
	components :{
	//	LoginBox : LoginBox
	},
	//inject: ['LoginBox'],
	methods: {

		handleSelect(key, keyPath) {

			this.activeIndex = key;
		},
		login(){
			this.$emit('LoginBox',{methods:'login'});
		},
		logout() {
			this.$emit('LoginBox',{methods:'logout'});
		},
		handleCommand(command) {
			this.user.currentRoute = command;
			this.$router.push({path: command, query: {}});
		},
		service()
		{
			window.open(this.config.CustomerServiceUrl,'', 'height=500,width=500,location=no,menubar=no,menubar=no');
		}
	},

	computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
		}),
		wallet(){
			//console.log(this.user.wallet);
			if (!this.user.wallet.deploy['WALLET'])
			{
				return false;
			}
			return this.user.wallet.deploy['WALLET'].amount.toFixed(2);
			//return x.toFixed(2);
		}
    },
	created() {


	},
	mounted() {
		//this.open();
	},
}
</script>
<style >
.header-user-menu .el-badge__content.is-fixed.is-dot{
  top: 6px;
}
.login-block .dot-item {
	vertical-align: top;
	margin-top:-2px;
} 
.login-block .dot-item .el-badge__content.is-fixed.is-dot{
    top: 16px;
    right: 10px;
}


.login-block .el-tag {
	font-size:14px !important;
}
.header-user-menu.el-dropdown-menu {
	margin-top:-5px;
}
.header-user-menu.el-dropdown-menu .popper__arrow{
	left:97px !important;
}
.main-wallet-icon {
    background-image: url(~assets/images/menu_money.png);
    width: 16px;
    height: 16px;
    background-size: cover;
	display:inline-block;
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 0px;
}

.menu-icon{
    width: 20px;
    height: 20px;
    background-size: cover;
	display:inline-block;
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 8px;
}
.menu-icon.wallet {
    background-image: url(~assets/images/menu_wallet.png);
}
.menu-icon.deposit {
    background-image: url(~assets/images/menu_deposit.png);
}
.menu-icon.bet-log {
    background-image: url(~assets/images/menu_betlog.png);
}
.menu-icon.logout {
    background-image: url(~assets/images/menu_logout.png);
}
.menu-icon.mail {
    background-image: url(~assets/images/menu_mail.png);
}
.menu-icon.info {
    background-image: url(~assets/images/menu_info.png);
}
.menu-icon.transfer-log {
    background-image: url(~assets/images/menu_transferlog.png);
}
.menu-icon.withdraw {
    background-image: url(~assets/images/menu_withdraw.png);
}
.header-mail-dot-number .el-badge__content {
	transform:scale(.8);
	right:73px;
	top:0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue